import { render, staticRenderFns } from "./ProvinceSelec.vue?vue&type=template&id=4796a8a9&scoped=true&"
import script from "./ProvinceSelec.vue?vue&type=script&lang=js&"
export * from "./ProvinceSelec.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceSelec.vue?vue&type=style&index=0&id=4796a8a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796a8a9",
  null
  
)

component.options.__file = "ProvinceSelec.vue"
export default component.exports